export default __webpack_public_path__ + "static/media/7SA84.5618b78d.jpg";